import { createResource, RouterContext } from 'react-resource-router';

import { ForgeNavigationData } from 'src/types/navigation';
import { urls } from 'src/urls/workspaces';
import { authRequest, jsonHeaders } from 'src/utils/fetch';

export const forgeWorkspaceNavigationResource = createResource({
  type: 'FORGE_WORKSPACE_MENU_ITEMS',
  getKey: ({ match }: RouterContext) =>
    `forge-workspace-menu-items:${match.params.workspaceSlug}`,
  maxAge: 1000 * 60 * 10, // 10 minute
  getData: async ({ match }): Promise<ForgeNavigationData | null> => {
    const { workspaceSlug } = match.params;

    if (!workspaceSlug) {
      throw new Error(
        'This resource can only be used on routes that contain a workspaceSlug in the path'
      );
    }

    const url = urls.api.internal.forgeMenuItems(workspaceSlug);
    const response = await fetch(authRequest(url, { headers: jsonHeaders }));

    if (!response.ok) {
      throw new Error(
        `Error fetching forge workspace menu item data (${response.status}): ${response.statusText}`
      );
    }

    const {
      menu_items,
      admin_menu_items,
      personal_settings_menu_items,
      workspace_menu_items,
    } = await response.json();

    return {
      forgeMenuItems: menu_items,
      forgeAdminMenuItems: admin_menu_items,
      personalSettingsForgeMenuItems: personal_settings_menu_items,
      workspaceForgeMenuItems: workspace_menu_items,
    };
  },
});
